/* eslint-disable react/no-danger */
import React from 'react';
import { format, parseISO } from 'date-fns';
import RouterLinkOrNot from '../../Shared/RouterLinkOrNot';

const CalendarEvent = ({
  title,
  image,
  href,
  bgColor = 'green',
  description,
  date,
}) => (
  <RouterLinkOrNot href={href} className="event-item event-item--calendar">
    {image && <img src={image} alt="Calendar Image" />}
    <div className="event-item__content" style={{ background: bgColor }}>
      <svg
        width="40"
        height="39"
        viewBox="0 0 40 39"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.2727 2.96672C27.2727 1.46048 28.4937 0.239441 30 0.239441C31.5062 0.239441 32.7272 1.46048 32.7272 2.96671V9.71143C32.7272 11.2177 31.5062 12.4387 30 12.4387C28.4937 12.4387 27.2727 11.2177 27.2727 9.71143V2.96672ZM3.63636 3.18408H5.5885V10.4723C5.5885 11.493 6.08957 12.4229 6.92526 13.0924C7.71223 13.7228 8.79973 14.1214 10.0205 14.1214C11.2218 14.1214 12.307 13.7209 13.0934 13.0814C13.9145 12.4137 14.4115 11.488 14.4115 10.4723V3.18408H25.5885V10.5904C25.5885 11.6359 26.0891 12.587 26.9208 13.2723C27.7089 13.9216 28.798 14.3317 30.0205 14.3317C31.2234 14.3317 32.3104 13.9198 33.0979 13.261C33.915 12.5775 34.4115 11.6307 34.4115 10.5904V3.18408H36.3636C38.3719 3.18408 40 4.75356 40 6.68962V34.7339C40 36.6699 38.3719 38.2394 36.3636 38.2394H3.63636C1.62806 38.2394 0 36.6699 0 34.7339V6.68962C0 4.75356 1.62806 3.18408 3.63636 3.18408ZM3.63635 34.7339V15.5095H36.3636V34.7339H3.63635ZM28.8221 31.2003V28.3587H24.8431C25.3442 28.0299 25.7949 27.6937 26.1952 27.3502C26.5956 27.0066 26.9456 26.6582 27.2452 26.3048C27.5449 25.9515 27.7954 25.592 27.9968 25.2264C28.1982 24.8607 28.3493 24.4877 28.45 24.1074C28.5507 23.727 28.601 23.343 28.601 22.9553C28.601 22.1553 28.4045 21.4437 28.0116 20.8204C27.6186 20.1971 27.0721 19.7076 26.3721 19.3518C25.6721 18.996 24.8603 18.8181 23.9368 18.8181C23.3621 18.8181 22.8279 18.8929 22.3342 19.0426C21.8405 19.1923 21.391 19.4131 20.9858 19.7051C20.5805 19.9972 20.2231 20.3591 19.9137 20.791C19.6042 21.2229 19.3414 21.7235 19.1252 22.2928L21.8073 23.6326C22.0235 23.1614 22.231 22.7823 22.43 22.4952C22.6289 22.2081 22.834 21.9995 23.0452 21.8695C23.2565 21.7394 23.4849 21.6744 23.7305 21.6744C24.0007 21.6744 24.2389 21.7382 24.4452 21.8658C24.6516 21.9934 24.8137 22.1627 24.9316 22.3737C25.0494 22.5848 25.1084 22.8154 25.1084 23.0657C25.1084 23.3357 25.0335 23.6301 24.8837 23.9491C24.7338 24.2681 24.5054 24.6203 24.1984 25.0055C23.8914 25.3908 23.4996 25.8104 23.0231 26.2644C22.5466 26.7183 21.983 27.2152 21.3321 27.7551C20.6812 28.2949 19.9358 28.879 19.0958 29.5071V31.2003H28.8221ZM16.6052 31.2003V19.0536H11.1084V22.2339H13.3631V31.2003H16.6052ZM9.99998 0.239441C8.49375 0.239441 7.27271 1.46048 7.27271 2.96672V9.71143C7.27271 11.2177 8.49375 12.4387 9.99998 12.4387C11.5062 12.4387 12.7273 11.2177 12.7273 9.71143V2.96671C12.7273 1.46048 11.5062 0.239441 9.99998 0.239441Z"
          fill="white"
        />
      </svg>
      <div>
        <h3 className="event-item__title">{title}</h3>
        <p className="event-item__date">
          {date && format(parseISO(date), 'd MMMM')}
        </p>
        <div dangerouslySetInnerHTML={{ __html: description }} />
      </div>
    </div>
  </RouterLinkOrNot>
);

export default CalendarEvent;
